<template>
  <header class="site-nav" :style="cssVars">
    <div class="site-nav__inner">
      <a class="brandmark" href="/" @click.prevent="scrollTop">
        <span class="brandmark__badge">{{ site.initials }}</span>
        <span class="brandmark__copy">
          <strong>{{ site.brand }}</strong>
          <span>{{ site.domain }}</span>
        </span>
      </a>
      <button class="menu-toggle" type="button" @click="isOpen = !isOpen">
        <span />
        <span />
        <span />
      </button>
      <nav class="nav-links" :class="{ 'nav-links--open': isOpen }">
        <a href="/" @click.prevent="scrollTo('platform')">Platform</a>
        <a href="/" @click.prevent="scrollTo('solutions')">Solutions</a>
        <a href="/" @click.prevent="scrollTo('workflow')">Process</a>
        <a href="/" @click.prevent="scrollTo('trust')">Coverage</a>
        <a class="nav-links__cta" href="/" @click.prevent="scrollTo('contact')">Contact</a>
      </nav>
    </div>
  </header>
</template>

<script>
import site from "../siteContent";

export default {
  data() {
    return {
      site,
      isOpen: false
    };
  },
  computed: {
    cssVars() {
      return {
        "--brand-primary": this.site.palette.primary,
        "--brand-secondary": this.site.palette.secondary,
        "--brand-accent": this.site.palette.accent
      };
    }
  },
  methods: {
    scrollTop() {
      this.isOpen = false;
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    scrollTo(id) {
      this.isOpen = false;
      const node = document.getElementById(id);
      if (node) {
        node.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.site-nav {
  position: fixed;
  inset: 0 0 auto 0;
  z-index: 30;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(18px);
  background: rgba(7, 13, 24, 0.78);
}

.site-nav__inner {
  width: min(1180px, calc(100% - 2rem));
  min-height: 5.25rem;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.brandmark {
  display: inline-flex;
  align-items: center;
  gap: 0.9rem;
  text-decoration: none;
}

.brandmark__badge {
  display: grid;
  place-items: center;
  width: 2.9rem;
  height: 2.9rem;
  border-radius: 1rem;
  background: linear-gradient(135deg, var(--brand-primary), var(--brand-secondary));
  color: #fff;
  font-weight: 800;
  font-family: "Space Grotesk", sans-serif;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.28);
}

.brandmark__copy {
  display: flex;
  flex-direction: column;
  gap: 0.16rem;
}

.brandmark__copy strong {
  color: #fff;
  font-family: "Space Grotesk", sans-serif;
  font-size: 1.05rem;
}

.brandmark__copy span {
  color: rgba(234, 241, 248, 0.7);
  font-size: 0.82rem;
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 1.15rem;
}

.nav-links a {
  color: rgba(234, 241, 248, 0.78);
  font-size: 0.95rem;
  text-decoration: none;
  transition: color 160ms ease, transform 160ms ease;
}

.nav-links a:hover {
  color: #fff;
  transform: translateY(-1px);
}

.nav-links__cta {
  padding: 0.78rem 1rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  color: #fff !important;
}

.menu-toggle {
  display: none;
  flex-direction: column;
  gap: 0.28rem;
  padding: 0;
  border: 0;
  background: transparent;
}

.menu-toggle span {
  display: block;
  width: 1.35rem;
  height: 2px;
  border-radius: 999px;
  background: #fff;
}

@media (max-width: 960px) {
  .menu-toggle {
    display: inline-flex;
  }

  .nav-links {
    position: absolute;
    right: 1rem;
    top: calc(100% + 0.75rem);
    width: min(18rem, calc(100vw - 2rem));
    padding: 1rem;
    border-radius: 1.1rem;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(6, 12, 22, 0.96);
    box-shadow: 0 24px 80px rgba(3, 8, 20, 0.34);
    flex-direction: column;
    align-items: stretch;
    opacity: 0;
    pointer-events: none;
    transform: translateY(-10px);
    transition: opacity 180ms ease, transform 180ms ease;
  }

  .nav-links--open {
    opacity: 1;
    pointer-events: auto;
    transform: translateY(0);
  }
}
</style>
